enum TimeDivisionType {
    DAY,
    HOUR,
    MINUTE,
    SECOND,
}

export default TimeDivisionType;
